import React from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  CardHeader,
  Modal,
} from "reactstrap";
//Import actions
import { getInvoice as getInvoiceApi } from "../../slices/thunks";
import { Link } from "react-router-dom";
import moment from "moment";
import { orderStatus } from "../../Components/constants/layout";
import { useDispatch } from "react-redux";
import SalesChannels from "../../Components/Common/SalesChannels";
import { Typography } from "@mui/material";
import RestrictedChannels from "../../Components/Common/RestrictedChannels";

const OrderDetail = ({ show, onCancelClick, onCloseClick, orders }) => {
  const dispatch = useDispatch();

  const getStatus = () => {
    if (orders?.ord_cancellationReason)
      return (
        <span
          style={{ width: "100px" }}
          className="badge text-uppercase text-dark bg-danger "
        >
          Cancelled
        </span>
      );
    switch (orders?.ord_status) {
      case orderStatus.STATUS_ORDERED:
        return (
          <span className="badge text-uppercase text-dark bg-success">
            ordered
          </span>
        );
      case orderStatus.STATUS_CANCELLED:
        return (
          <span className="badge text-uppercase text-dark bg-danger">
            cancelled
          </span>
        );
      case orderStatus.STATUS_EXPIRED:
        return (
          <span className="badge text-uppercase text-dark bg-warning">
            {" "}
            EXPIRED
          </span>
        );
      default:
        return <span></span>;
    }
  };

  const getInvoice = () => {
    const data = {
      ord_id: orders?.ord_id,
    };
    dispatch(getInvoiceApi(data));
  };
  return (
    <Modal isOpen={show} toggle={onCloseClick} centered={true} size="xl">
      <div className="modal-header">
        <h5 className="modal-title mt-0">Order Details</h5>
        <button
          onClick={onCloseClick}
          type="button"
          className="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </div>
      <div className="modal-body">
        <Container fluid>
          <Row>
            <Col>
              <div className="d-sm-flex align-items-center mb-2">
                {(orders?.ord_status == orderStatus.STATUS_ORDERED ||
                  orders?.ord_status == orderStatus.STATUS_SHIPPED) && (
                  <div className="flex-shrink-0 mt-2 mt-sm-0 ms-1 ">
                    <Link
                      to="#"
                      onClick={getInvoice}
                      className="btn btn-soft-success btn-sm"
                    >
                      <i className="ri-download-2-fill align-middle me-1"></i>{" "}
                      Invoice
                    </Link>
                  </div>
                )}
              </div>
              <Card>
                <CardHeader>
                  <div className="d-flex align-items-center">
                    <h5 className="card-title flex-grow-1 mb-0">
                      Order# {orders?.ord_id}
                    </h5>
                    <div className="flex-shrink-0">{getStatus()}</div>
                  </div>
                  {orders?.ord_cancellationReasonText != null && (
                    <div className="mt-2">
                      <p className="text-muted mb-0">
                        <b>Cancellation Reason:</b>{" "}
                        {orders?.ord_cancellationReasonText}
                      </p>
                    </div>
                  )}
                </CardHeader>
                <CardBody>
                  <div className="flex-grow-1 ms-3">
                    <Row>
                      <div>
                        <b>Ordered Date: </b>
                        {moment(orders?.ord_dateCreated).format(
                          "MM-DD-Y, h:mm a"
                        )}
                      </div>
                    </Row>
                    {orders?.ordDatePurchaseOrder && (
                      <Row>
                        <div>
                          <b>Purchased Date: </b>
                          {moment(orders?.ordDatePurchaseOrder).format(
                            "MM-DD-Y, h:mm a"
                          )}
                        </div>
                      </Row>
                    )}
                    <Row>
                      <div>
                        <b>Quantity: </b>
                        {orders?.ord_quantity}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>Price: </b>{" "}
                        {orders?.ord_totalPrice.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>Extended Lead Time: </b>
                        {orders?.ord_extendedLeadTime
                          ? `${orders.ord_extendedLeadTime} days`
                          : "N/A"}
                      </div>
                    </Row>
                    <Row>
                      <div>
                        <b>MAP (Minimum Advertised Price): </b>
                        {orders?.ord_MAP
                          ? orders.ord_MAP.toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })
                          : "N/A"}
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Sales Channel: </b>
                        <SalesChannels channel={orders?.ord_salesChannel} />
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Restricted Channel: </b>
                        <RestrictedChannels
                          channel={orders?.ord_restrictedChannel}
                        />
                      </div>
                    </Row>
                    <Row className="mt-1">
                      <div>
                        <b>Important notes:</b>
                        <Typography variant="body2" color="textSecondary">
                          {orders?.ord_importantNotes}
                        </Typography>
                      </div>
                    </Row>
                  </div>
                </CardBody>
              </Card>
              <Card>
                <CardHeader>
                  <div className="d-sm-flex align-items-center">
                    <h5 className="card-title flex-grow-1 mb-0">
                      Product Detail
                    </h5>
                  </div>
                </CardHeader>
                <CardBody>
                  <div className="flex-grow-1 ms-3">
                    <Row>
                      <h5>
                        <b>{orders?.productName}</b>
                      </h5>
                    </Row>
                    <Row>
                      <div>
                        <b>Product codes: </b>
                        <span>
                          {orders?.productUPC
                            ? orders?.productUPC
                            : "No UPC Code"}
                          {orders?.productASIN && (
                            <span> / {orders?.productASIN}</span>
                          )}
                        </span>
                      </div>
                    </Row>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-secondary"
          data-bs-dismiss="modal"
          onClick={onCloseClick}
        >
          Close
        </button>
      </div>
    </Modal>
  );
};

export default OrderDetail;
